var ScoutingDepartmentPlayerContactController = (function () {
    function ScoutingDepartmentPlayerContactController() {
    }
    return ScoutingDepartmentPlayerContactController;
}());
angular.module('app.scouting').component('scoutingDepartmentPlayerContact', {
    templateUrl: 'scouting/components/department-player-contact.html',
    controller: ScoutingDepartmentPlayerContactController,
    bindings: {
        player: '<',
        user: '<',
    },
});
;